import React from 'react';
import classNames from 'classnames';

const ns = `tab`;

// Tab must have a unique key prop that is the same across re-renders.

const Tab = ({
	// title,
	children,
	index,
	selected,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<div
			id={`tabpanel_${ index }`}
			className={rootClassnames}
			name={`tabpanel_${ index }`}
			role={`tabpanel`}
			aria-labelledby={`tab_${ index }`}
			aria-hidden={!selected()}
		>
			{children}
		</div>
	);
};

export default Tab;
